import { render, staticRenderFns } from "./PxHeader.vue?vue&type=template&id=a71c4596&"
import script from "./PxHeader.vue?vue&type=script&lang=js&"
export * from "./PxHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports